import React from 'react';
import confirmIcon from '../../../assets/images/confirm_icon.svg';
import { RxCross2 } from 'react-icons/rx';
import { MdOutlineDone } from 'react-icons/md';

const ConfirmationModal: React.FC<any> = ({ logout, setShowConfirmModalLogout }) => {
  return (
    <>
      <section className='w-full'>
        <div className='fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-50'>
          <div className='bg-white rounded-xl shadow-xl max-w-xs sm:max-w-xs md:max-w-xl lg:max-w-xl w-full'>
            <div className='p-4 sm:p-4 md:p-6 lg:p-8'>
              <div className={"flex justify-center items-start gap-3 'border-gray-300 bg-white'}"}>
                <div className='bg-white text-center '>
                  <img src={confirmIcon} alt='Success' className='mx-auto size-40 sm:size-40 md:size-44 lg:size-44' />
                  <h2 className='font-rubik text-[20px] sm:text-[20px] md:text-[40px] lg:text-[40px] font-bold text-[#4A2D1A] mb-0 sm:mb-0 md:mb-2 lg:mb-2'>
                    Are you sure?
                  </h2>
                  <p className='font-poppins text-sm sm:text-sm md:text-xl lg:text-xl text-black'>
                    Do you want to logout?
                  </p>
                </div>
              </div>
              <div className='flex flex-col sm:flex-row justify-between gap-4 mt-4'>
                <button
                  className='flex justify-center items-center font-poppins bg-white text-red-800 border border-red-800 
                                    py-2 px-4 text-sm sm:text-sm md:text-sm 
                                    rounded-lg hover:bg-red-800 hover:text-white transition cursor-pointer'
                  onClick={() => setShowConfirmModalLogout(false)}
                >
                  <RxCross2 className='text-base mr-2' />
                  Cancel
                </button>

                <button
                  onClick={() => logout()}
                  className='flex  justify-center items-center font-poppins bg-red-800 text-white border border-red-800 
                                        py-2 px-4 text-sm sm:text-sm md:text-sm 
                                        rounded-lg hover:bg-white hover:text-red-800 transition cursor-pointer'
                >
                  <MdOutlineDone className='text-base mr-2' />
                  OK
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ConfirmationModal;
